import { render, staticRenderFns } from "./activeAccount.vue?vue&type=template&id=5e40d66c"
import script from "./activeAccount.vue?vue&type=script&lang=js"
export * from "./activeAccount.vue?vue&type=script&lang=js"
import style0 from "./activeAccount.vue?vue&type=style&index=0&id=5e40d66c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports